import { Box } from "@mui/material";
import { HoverImage, LabelColumnV2, LinkColumnV2, Messages } from "../../components/DataGridV2/DataColumnsV2";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { formatDate, repairRequestDbStatuses } from "../../_helpers";
import { Chat, Image } from "@mui/icons-material";

export const getBuyerRepairRequestColumns = ({
    t,
    keyPrefix,
    i18n,
    apiRef,
  }) =>{
    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        mode: "client",
        getValueForFilter: (rowData, extraData) => {
          let text = ""
          switch (extraData.fieldName) {
            case "messageCount":
              text = rowData.messageCount != null ? rowData.messageCount.toString() : "";
              break;
            default:
              text = rowData[extraData.fieldName]
              break;
          }
          return text
        },
        getValueForCopy: (rowData, extraData) => {
          let text = ""
          switch (extraData.fieldName) {
            case "date":
              text = rowData.date ? formatDate(new Date(rowData?.date)) : ""
              break;
            default:
              text = rowData[extraData.fieldName]
              break;
          }
          return text
        },
      })
return  [
    {
      download: false,
      print: true,
      field: "attachments",
      headerName: t("general.image"),
      editable: false,
      disableColumnMenu: true,
      flex: 1,
      align: "center",
      filterable: false,
      minWidth: 45,
      maxWidth: 45,
      forceApplyWidth: true,
      sortable: false,
      renderCell: (params) => {
        const imageId = params?.row?.attachments?.[0]?.attachmentId;
        const index = params?.row?.requestId;
        if (imageId) {
          return (
            <HoverImage
              defaultSize={20}
              imageId={imageId}
              index={index}
            />
          );
        }
        return (
          <Box
            sx={[
              {
                boxShadow: 1,
                borderRadius: 1,
                width: 20,
                height: 20,
                backgroundImage: `url(/Content/Images/Logos/Apps/reparation-tools.png)`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                "&:hover": {
                  transform: "scale(3)",
                  position: "absolute",
                  zIndex: 1000,
                },
              },
              index === 0
                ? {
                  "&:hover": {
                    marginTop: '30px'
                  }
                }
                : {
                  "&:hover": {
                    marginTop: 0
                  }
                }
            ]}
          />

        );
      },
      renderHeader: () => (
        <Box component="div" sx={{ textAlign: "center" }}>
          <Image />
        </Box>
      ),
    },
    {
      download: true,
      print: true,
      field: "number",
      headerName: t("general.number"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LinkColumnV2
            to={'/nazorg/details/' + rowData.requestId}
            label={rowData.number}
            cellSubMenuOptions={{ options: getOptions({ field: "number", isQuickFilterDisplay: Boolean(rowData.number) }), extraData: { fieldName: "number" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "location",
      headerName: t("general.location"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.location}
            cellSubMenuOptions={{ options: getOptions({ field: "location", isQuickFilterDisplay: Boolean(rowData.location) }), extraData: { fieldName: "location" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "desc",
      headerName: t("general.shortDescription"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.desc}
            cellSubMenuOptions={{ options: getOptions({ field: "desc", isQuickFilterDisplay: Boolean(rowData.desc) }), extraData: { fieldName: "desc" } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "date",
      headerName: t('general.date'),
      flex: 1,
      minWidth: 90,
      type: "date",
      valueGetter: (params) => {
        if (!params) return "";
        return new Date(params);
      },
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2 date={rowData.date}
          cellSubMenuOptions={{ options: getOptions({ field: "date", isQuickFilterDisplay: rowData?.date }), extraData: { fieldName: "date", type: "date" } }}
          request={rowData}
        />
      },
    },
    {
      download: true,
      print: true,
      field: "status",
      headerName: t("general.status"),
      type: "singleSelect",
      valueOptions: Object.values(repairRequestDbStatuses).map((repairRequestStatusKey) => ({ value: repairRequestStatusKey, label: repairRequestStatusKey })),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.status}
            cellSubMenuOptions={{ options: getOptions({ field: "status", isQuickFilterDisplay: Boolean(rowData.status) }), extraData: { fieldName: "status", type: "singleSelect", } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "unreadMessagesCount",
      headerName: t("chat.messages"),
      type: "number",
      editable: false,
      maxWidth: 45,
      forceApplyWidth: true,
      minWidth: 45,
      resizable: false,
      sortable: false,
      disableRowSelectionOnClick: true,
      flex: 1,
      headerAlign: "center",
      filterable: true,
      renderHeader: () => (
        <Box sx={{
          mr: 0.6
        }}>
          <Chat size="small" />
        </Box>
      ),
      renderCell: (parmes) => {
        const request = parmes.row;
        return <Messages request={request} t={t} options={getOptions({ sortable: false, field: "unreadMessagesCount", isQuickFilterDisplay: Boolean(request.unreadMessagesCount) })} />
      },
    },
  ];
}